import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="financial-records--filters"
export default class extends Controller {
  static targets = ['form', 'dateFrom', 'dateTo', 'reference']

  connect() {
    this.setupAutoSubmit()
  }

  setupAutoSubmit() {
    let timeout
    this.referenceTarget?.addEventListener('input', (e) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        this.submitForm()
      }, 500) // 500ms delay
    })

    this.dateFromTarget?.addEventListener('change', () => this.submitForm())
    this.dateToTarget?.addEventListener('change', () => this.submitForm())
  }

  submitForm() {
    this.formTarget.requestSubmit()
  }
}
